import { ImageVariants } from '@/core/media/typings'
import { parseMediaUrl } from '@/core/media/utils/parse-media-url'
import { variantUrls } from '@/core/media/utils/variant-urls'

function getConfiguredStorageHost(): string | null {
  const hostStorage = process.env.HOST_STORAGE

  if (!hostStorage) {
    return null
  }

  try {
    return new URL(hostStorage).host
  } catch {
    return null
  }
}

/**
 * Returns the safest display URL for an image.
 *
 * @param originalUrl - The original media URL stored for the asset.
 * @param variant - The preferred variant to use when the host/path pattern is trusted.
 * @returns A stable image URL for UI rendering.
 */
export function getDisplayImageUrl(originalUrl: string, variant: ImageVariants): string {
  const parsedUrl = parseMediaUrl(originalUrl)

  if (!parsedUrl) {
    return originalUrl
  }

  const host = parsedUrl.host.replace(/^https?:\/\//, '')
  const configuredStorageHost = getConfiguredStorageHost()

  if (!configuredStorageHost || host !== configuredStorageHost) {
    return originalUrl
  }

  return variantUrls(originalUrl)[variant]
}
